import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withXhr,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { deployUrl } from '@thiememeulenhoff/nx-sdk';
import { provideSentry } from '@thiememeulenhoff/ng-sdk';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor } from '../core/interceptors/auth.interceptor';
import { apiInterceptor } from '../core/interceptors/api.interceptor';
import { unauthorizedInterceptor } from '../core/interceptors/unauthorized.interceptor';
import { provideAppBootstrap } from '../providers/app-bootstrap.initializer';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSentry,
    provideHttpClient(
      withXhr(),
      withInterceptors([
        authInterceptor,
        apiInterceptor,
        unauthorizedInterceptor,
      ]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideOAuthClient(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideAppBootstrap(),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => `${deployUrl()}${config.src}`,
    },
  ],
};
